import { API } from 'aws-amplify';

const API_NAME = 'admin-api-v2';

export const getPlatformStats = async () => {
  return API.get(API_NAME, '/stats?scope=platform', {});
};

export const getTenantStats = async (tenantId) => {
  return API.get(API_NAME, `/stats?scope=tenant&tenantId=${tenantId}`, {});
};
